import React, { useEffect, useState } from 'react';
import { useField } from 'react-final-form';

import * as Styled from './InputField.styled';

export interface InputFieldProps {
  className?: string;
  name: string;
  fieldName: string;
  placeholder?: string;
  valid?: boolean | null;
  type?: string;
  /* eslint-disable no-unused-vars */
  validator: (value: string) => string | undefined;
  onBlur?: () => void;
  /* eslint-disable no-unused-vars */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onValidate?: (result: {
    name: string;
    valid: boolean;
    message?: string;
  }) => void;
}

export const InputField: React.FC<InputFieldProps> = ({
  className,
  name,
  fieldName,
  placeholder = '',
  type = 'text',
  validator,
}) => {
  const [errors, setErrors] = useState<string[]>([]);

  const {
    input,
    meta: { error, touched, active },
  } = useField(fieldName, {
    validate: value => validator(value),
  });

  useEffect(() => {
    if (!active && error && touched) {
      if (errors.includes(error)) return;

      setErrors([...errors, error]);
    }
  }, [error, touched, errors, active]);

  // Only show error when field is not active and has been touched
  const shouldShowError = !active && error && touched;

  return (
    <Styled.Wrapper className={className}>
      <Styled.Input
        error={shouldShowError}
        name={name}
        type={type}
        className={error ? 'invalid' : ''}
        placeholder={placeholder}
        value={input.value}
        onChange={input.onChange}
        onFocus={input.onFocus}
        onBlur={input.onBlur}
        aria-invalid={error}
      />
      {shouldShowError && (
        <Styled.Error>
          <Styled.ErrorIcon name="form-error" />
          <Styled.ErrorMessage>{error}</Styled.ErrorMessage>
        </Styled.Error>
      )}
    </Styled.Wrapper>
  );
};
